export enum OfferType {
  Regular = 1,
  School = 2,
  Elitetutoring = 3,
}
